import useIPA from '@/auth/jwt/useDevice'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 10,
  pageOptions: [10, 25, 50, 100],
  totalRows: 1,
  sortOptions: [],
  fields: [
    { key: 'no', label: 'no', sortable: true },
    { key: 'faq_category_name', label: 'category', sortable: true },
    { key: 'question', label: 'question', sortable: true },
    { key: 'answer', label: 'answer', sortable: true },
    { key: 'created_at', label: 'Created At', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action' },
  ],
  items: [],
  category: {
    perPage: 10,
    pageOptions: [10, 25, 50, 100],
    totalRows: 1,
    options: [],
    sortOptions: [],
    fields: [
      { key: 'no', label: 'no', sortable: true },
      { key: 'name', label: 'name', sortable: true },
      { key: 'description', label: 'description', sortable: true },
      { key: 'created_at', label: 'Created At', sortable: true },
      { key: 'status', label: 'Status', sortable: true },
      { key: 'action', label: 'Action' },
    ],
    items: [],
  },
})

// getters
const getters = {}

// actions
const actions = {
  getCategory({ commit }) {
    const param = { status: 'master/faq-categories?status=AC' }
    useIPA.get(param).then(response => {
      const faq = {
        rows: response.data.data,
        pages: [10, 25, 50, 150],
      }
      commit('setCategory', { ...faq })
    })
  },
  getAll({ commit }) {
    const param = { status: 'master/faqs?status=AC' }
    useIPA.get(param).then(response => {
      const device = {
        rows: response.data.data,
        pages: [10, 25, 50, 150],
      }
      commit('setData', { ...device })
    })
  },
  getById({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/faqs/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  formPostPut({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = {
        faq_category_id: formData.select_1,
        question: formData.text_1,
        answer: formData.textarea_1,
        status: 'AC',
      }
      const param = { rawData, url: 'internal/master/faqs', id: formData.id }
      useIPA.postput(param)
        .then(response => {
          router.push({ name: 'project-faq' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  remove({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { url: 'internal/master/faqs', id }
      useIPA.delete(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  getByIdCategory({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/faq-categories/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  formPostPutCategory({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = {
        site_id: formData.select_1,
        name: formData.text_1,
        description: formData.text_2,
        status: 'AC',
      }
      const param = { rawData, url: 'internal/master/faq-categories', id: formData.id }
      useIPA.postput(param)
        .then(response => {
          router.push({ name: 'project-faq-category' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  removeCategory({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { url: 'internal/master/faq-categories', id }
      useIPA.delete(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
}

// mutations
const mutations = {
  setCategory(state, faq) {
    faq.rows.forEach((element, index) => {
      element.no = index + 1
    })
    state.category.items = faq.rows
    state.category.totalRows = faq.rows.length
    state.category.options = []
    for (let i = 0; i < faq.rows.length; i++) {
      const option = []
      for (const key in faq.rows[i]) {
        if (key === 'id') {
          option.value = faq.rows[i][key]
        } else if (key === 'name') {
          option.title = faq.rows[i][key]
        } else if (key === 'id') {
          option.oid = faq.rows[i][key]
        }
      }
      state.category.options.push({ ...option })
    }
  },
  setData(state, faq) {
    faq.rows.forEach((element, index) => {
      element.no = index + 1
    })
    state.items = faq.rows
    state.totalRows = faq.rows.length
    state.options = []
    for (let i = 0; i < faq.rows.length; i++) {
      const option = []
      for (const key in faq.rows[i]) {
        if (key === 'id') {
          option.value = faq.rows[i][key]
        } else if (key === 'name') {
          option.title = faq.rows[i][key]
        } else if (key === 'id') {
          option.oid = faq.rows[i][key]
        }
      }
      state.options.push({ ...option })
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
